import { render, staticRenderFns } from "./UploadPhoto.vue?vue&type=template&id=5b90c34c&scoped=true&"
import script from "./UploadPhoto.vue?vue&type=script&lang=js&"
export * from "./UploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhoto.vue?vue&type=style&index=0&id=5b90c34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b90c34c",
  null
  
)

export default component.exports